import { checkPermissions } from './checkPermissions';

export const can_view_public_offer = (offer, roles = []) => {
    const fake = offer?.fakeOffer === true || offer?.setupData?.fakeOffer === true
        || [offer?.code, offer?.ofrId].some(code => /^F-OFR-/i.test(String(code || '')));
    return !fake || checkPermissions('Scout', roles);
};
